import { Layout } from 'antd'
import { SiderProps } from 'antd'

type Props = SiderProps

const Sider = ({ children, ...rest }: Props) => {
  return <Layout.Sider {...rest}>{children}</Layout.Sider>
}

export default Sider
